export default __webpack_public_path__ + "static/media/icon-plus.d742536e.svg";